/**
 * Detect language of text and return ISO 639-3 language code for API (e.g. "eng", "spa", "hin").
 * Used when sending user_query to chat/avatar APIs so the backend can respond in the correct language.
 */
import { franc } from "franc-min";

const DEFAULT_CODE = "eng";

export function detectLanguageCode(text) {
  const cleaned = (text || "").trim();
  if (cleaned.length < 5) {
    return DEFAULT_CODE;
  }
  const code = franc(cleaned, { minLength: 5 });
  if (code === "und") {
    return DEFAULT_CODE;
  }
  return code;
}
